'use client'

import { useMemo } from 'react'

import { FavouriteIcon, Timer02Icon } from '@hugeicons-pro/core-solid-rounded'

import { HugeiconsIcon } from '@hugeicons/react'

import { useLevelContext } from '@/features/level-play'
import { useFlow } from '@/shared/lib/steps-flow'
import { cn } from '@/shared/lib/utils'

type Step = {
  challengeId: number
  time_limit?: number | null
}

type FlowState = {
  steps: Step[]
  currentIndex: number
  timeLeft: number
  lives: number
}

export const LevelHeartsAndCountdown: React.FC = () => {
  const { level } = useLevelContext()

  const flow = useFlow()
  const { state } = flow

  const step = state.steps[state.currentIndex] as Step | undefined
  const challenge = useMemo(() => {
    if (!level || !step) return undefined
    return level.active_challenges?.find(
      (c: { id: number }) => c.id === step.challengeId
    )
  }, [level, step])

  const showTimer = Boolean(step?.time_limit && step.time_limit > 0)

  const timerSlots = String(step?.time_limit ?? 0).length || 2
  const timerMinWidth = `${Math.max(timerSlots, 2)}ch`

  return (
    <div className="flex items-center justify-center gap-2 px-0 animate__animated animate__fadeIn">
      {showTimer && (
        <div
          className={cn(
            'flex items-center justify-center gap-2 rounded-full bg-jacaranda/20 py-1 pl-3 pr-2 text-lg'
          )}
        >
          <span
            aria-live="polite"
            className="block font-bold leading-none text-right font-mono tabular-nums"
            style={{ minWidth: timerMinWidth }}
          >
            {state.timeLeft}
          </span>
          <HugeiconsIcon
            icon={Timer02Icon}
            className="rounded-full bg-white p-1 text-dark"
            size={22}
          />
        </div>
      )}

      <div className="flex items-center justify-center gap-2 rounded-full bg-jacaranda/20 py-1 pl-3 pr-2 text-lg">
        <span className="block font-sans text-xl font-semibold leading-none">
          {state.lives}
        </span>
        <HugeiconsIcon
          icon={FavouriteIcon}
          className="rounded-full bg-white p-1 text-tie"
          size={25}
          aria-label="Vidas"
        />
      </div>
    </div>
  )
}
